import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './msalConfig';
import App from './App';
import './index.css';

// ResizeObserver loop error suppression
// Primary suppression is in public/index.html (runs before bundle).
// This is a backup: remove the CRA error overlay DOM element if it still appears.
const overlayObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      // CRA overlay iframe: z-index 2147483647, position fixed, full screen
      if (node.tagName === 'IFRAME' && node.style.position === 'fixed' &&
          (node.style.zIndex === '2147483647' || node.id === 'react-dev-utils-webpack-hot-dev-client-overlay')) {
        node.remove();
        return;
      }
    }
  }
});
if (typeof document !== 'undefined') {
  overlayObserver.observe(document.documentElement, { childList: true, subtree: true });
}

// Create and initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  // Set active account if one exists
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  // Listen for login events to set active account
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  );
});
